import { render, staticRenderFns } from "./WYSIWYGInput.vue?vue&type=template&id=0d77be6f&scoped=true&"
import script from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
import style0 from "./WYSIWYGInput.vue?vue&type=style&index=0&id=0d77be6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d77be6f",
  null
  
)

export default component.exports